var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconComment2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00492 0.598633C3.22783 0.598633 0.976562 2.8499 0.976562 5.62699V17.9185C0.976562 20.6956 3.22784 22.9469 6.00492 22.9469H7.49444V28.1928C7.49444 28.9634 8.44691 29.3255 8.95887 28.7495L14.1168 22.9469H29.4706C32.2477 22.9469 34.4989 20.6956 34.4989 17.9185V5.62699C34.4989 2.84991 32.2477 0.598633 29.4706 0.598633H6.00492Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment2);
export default __webpack_public_path__ + "static/media/icon_comment_2.946f8693d51d9bcef28b2b96073bf842.svg";
export { ForwardRef as ReactComponent };